import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import { ChartOptions } from 'chart.js';
import { FormBuilder, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  isShown: boolean = true;
  Message = "";
  Sucess = false;
  loggedUser: string = ''
  loggedUserDepartment: string = ''
  Notification = false
  loaderShown = false
  SelectedYear: string = ''
  SelectedMonth: string = ''
  DepartmentDropdown: any = []
  UserDropdown: any = []

  // percentage varibles

  QualifiedPercentage: number[] = []
  NonQualifiedPercentage: number[] = []
  RecivablePercentage: number[] = []

  // misc and search varibles
  SearchString: string = ''
  TotalYear: any = []
  Month: any = [
    { month: 'January', value: '01' },
    { month: 'February', value: '02' },
    { month: 'March', value: '03' },
    { month: 'April', value: '04' },
    { month: 'May', value: '05' },
    { month: 'June', value: '06' },
    { month: 'July', value: '07' },
    { month: 'August', value: '08' },
    { month: 'September', value: '09' },
    { month: 'October', value: '10' },
    { month: 'November', value: '11' },
    { month: 'December', value: '12' }
  ];

  UserType: any = [
    "Sales_Promoter", "Salesman", "UAE_Wholesale_Salesman"
  ]
  Department = {
  selected_employee_ids: [] as string[],
  selected_departments_ids: [] as string[],
  selected_brand_ids: [] as string[],
  selected_user_types: [] as string[]
}
  
  selectedDepartments: any[] = [];

  get allDeptsSelected(): boolean {
    return this.DepartmentDropdown.length > 0 &&
          this.selectedDepartments.length === this.DepartmentDropdown.length;
  }

  SelectedUsertype: string = 'Sales_Promoter'
  SelectedUser:string =''

  FilterLoader: boolean = false

  // custom color for chart

  // colorpalets
  SaleStarted = '#FFBF00' //amber
  NotStarted = '#FF4500' //red
  Active = '#4CBB17' //green
  QnotStarted = '#E9EAEC' //silverGray
  Doubtful = '#0A0A0A' //jetBlack

  //  condition check

  userTypeCheck: string = ''
  EmployeeId: string = ''

  constructor(private adminService: ServiceService, private formBuilder: FormBuilder,) {
    this.loggedUser = localStorage.getItem('EmployeeName') || ''
    this.loggedUserDepartment = localStorage.getItem('department') || 'N/A'
  }


  ngOnInit(): void {
    const date = new Date();
    this.SelectedMonth = (date.getMonth() + 1).toString().padStart(2, '0')
    this.SelectedYear = (date.getFullYear()).toString();
    // this.SearchString = `?year_month=${this.SelectedYear}-07`
    this.userTypeCheck = localStorage.getItem('userTypecon') || ''
    this.EmployeeId = localStorage.getItem('admin_id') || ''
    console.log('All localStorage:', JSON.stringify(localStorage));

    this.getYears()
    this.checkUsertype()
    // if (this.userTypeCheck?.toUpperCase() == 'ADMIN') {
    //   this.getPiechart()
    // } else if (this.userTypeCheck?.toUpperCase() == 'SALESMAN' || this.userTypeCheck?.toUpperCase() == 'SALES_PROMOTER' || this.userTypeCheck?.toUpperCase() == 'UAE_WHOLESALE_SALESMAN') {
    //   this.getPiechartEmployee()
    // }
    this.userDropdown()
    this.departmentDropdown()
  }

  onDepartmentChange(value: any[]) {
    this.Department.selected_departments_ids = value.map((item) => item.department_id ?? item);
    this.checkUsertype();
  }
  
  toggleSelectAllDepts() {
    if (this.allDeptsSelected) {
      this.selectedDepartments = [];
    } else {
      this.selectedDepartments = this.DepartmentDropdown.map((d: any) => d.department_id);
    }
    this.Department.selected_departments_ids = this.selectedDepartments;
    this.checkUsertype();
  }

  ZincDB() {
    this.loaderShown = true;
    this.adminService.DataSync().subscribe((res) => {
      this.Sucess = res.success
      if (this.Sucess) {
        this.Message = "Successfully Synchronized"
      }
      else {
        this.Message = "Failed"
      }
       this.loaderShown=false;
      this.Notification = true
      setTimeout(() => {
        this.Notification = false
      }, 1500);
    },(error)=>{
      alert('Server Error')
      this.loaderShown=false;
    })
  }




  getYears() {
    const currentYear = new Date().getFullYear();
    for (let year = 2000; year <= currentYear; year++) {
      this.TotalYear.push(year);
    }
  }

  departmentDropdown() {
    this.adminService.DepartmentDropdown().subscribe({
      next: (response) => {
        console.log('dropdown', response);
        this.DepartmentDropdown = response.data

      },
      error: (err) => {
        console.log("api error");

      }
    })
  }
  
  get selectedDepartmentNames(): string {
    if (!this.selectedDepartments || this.selectedDepartments.length === 0) return 'All';
    return this.DepartmentDropdown
      .filter((d: any) => this.selectedDepartments.includes(d.department_id))
      .map((d: any) => d.department_name)
      .join(', ');
  }

  userDropdown(){
    this.adminService.SearchUser(this.selectedEmployeename,this.SelectedUsertype,0).subscribe({
      next: (respone) => {
        this.UserDropdown = respone.data
      }
    })
  }

  selectedEmployeename =''
  Viewemployee:boolean = false 

  employeeSelected(value:any){
    console.log(value);
    if(value != undefined){
      this.Viewemployee = true
      this.EmployeeId = value.user_employee_id
      this.getPiechartEmployee()
    }else{
      this.Viewemployee = false
      this.EmployeeId = localStorage.getItem('admin_id') || ''
      this.getPiechart()
    }
    // this.selectedEmployeename = value.user_fullname
    
  }
  getUserSearch(value:any){
    console.log(value);
    if(value.items.length == 0){
      this.selectedEmployeename = value.term
      this.userDropdown()
    }
    
  }

  // Employee or admin view select condition fn
  IsAdmin = false
  resetChartData() {
    this.pieChartDatasets = [{ ...this.pieChartDatasets[0], data: [0, 0, 0, 0] }];
    this.nonpieChartDatasets = [{ ...this.nonpieChartDatasets[0], data: [0, 0, 0, 0] }];
    this.ReceivablespieChartDatasets = [{ ...this.ReceivablespieChartDatasets[0], data: [0, 0, 0, 0, 0] }];
    this.EmployeeCustomercountpieChartDatasets = [{ ...this.EmployeeCustomercountpieChartDatasets[0], data: [0, 0, 0, 0] }];
    this.EmployeeCustomerpieChartDatasets = [{ ...this.EmployeeCustomerpieChartDatasets[0], data: [0, 0, 0, 0] }];
  }
  // new
  checkUsertype() {
  this.SearchString = `?year_month=${this.SelectedYear}-${this.SelectedMonth}&selected_user_type=${this.SelectedUsertype}`
  this.Department.selected_user_types = [this.SelectedUsertype]
  this.resetChartData()
    if (this.userTypeCheck.toUpperCase() == 'ADMIN') {
      this.IsAdmin = true
      this.getPiechart()
    } else if (this.userTypeCheck?.toUpperCase() == 'SALESMAN' || this.userTypeCheck?.toUpperCase() == 'SALES_PROMOTER' || this.userTypeCheck?.toUpperCase() == 'UAE_WHOLESALE_SALESMAN') {
      this.IsAdmin = false
      this.Viewemployee = true
      this.getPiechartEmployee()
    }
   
    // if (this.IsAdmin) {
    //   this.getPiechart()
    // } else {
    //   this.getPiechartEmployee()
    // }
this.userDropdown()

  }



  // EmployeeView
  getPiechartEmployee() {
    this.FilterLoader = true
    // debugger
    this.adminService.dashboardPiechartEmployeeWise(this.EmployeeId, this.SearchString).subscribe({
      next: (response) => {
        console.log('ind', response);
        this.FilterLoader = false
        if (response.success) {
          // Indivitual Month chart
          var NonQualifiedActive = response.data[0].sales_list[0].active_non_qualified[0].customer_ids_count
          var NonQualifiedInactive = response.data[0].sales_list[0].inactive_non_qualified[0].customer_ids_count
          var Qualifiedactive = response.data[0].sales_list[0].active_qualified[0].customer_ids_count
          var QualifiedInactive = response.data[0].sales_list[0].inactive_qualified[0].customer_ids_count
          this.salesCustomercount(NonQualifiedActive, NonQualifiedInactive, Qualifiedactive, QualifiedInactive)
          var NonQualifiedActivevalue = response.data[0].sales_list[0].active_non_qualified[0].sales_total
          var NonQualifiedInactivevalue = response.data[0].sales_list[0].inactive_non_qualified[0].sales_total
          var Qualifiedactivevalue = response.data[0].sales_list[0].active_qualified[0].sales_total
          var QualifiedInactivevalue = response.data[0].sales_list[0].inactive_qualified[0].sales_total
          this.salesCustomerValue(NonQualifiedActivevalue, NonQualifiedInactivevalue, Qualifiedactivevalue, QualifiedInactivevalue)
          // avg ,recivable and others chart
          // qualified
          var SaleStarted = response.data[0].qualified_non_qualified_sales_list[0].qualified[0].sales_started_count
          var NoSaleStarted = response.data[0].qualified_non_qualified_sales_list[0].qualified[0].no_sales_count
          var ActiveCustomer = response.data[0].qualified_non_qualified_sales_list[0].qualified[0].qualified_count
          var ActiveQualifiedSales = response.data[0].qualified_non_qualified_sales_list[0].qualified[0].sales_only_qualified_customer_ids?.length || 0
          this.qualifiedCustomer(SaleStarted, NoSaleStarted, ActiveCustomer, ActiveQualifiedSales)
          //non qualified
          var NonQSaleStarted = response.data[0].qualified_non_qualified_sales_list[0].non_qualified[0].sales_started_count
          var NonQNoSaleStarted = response.data[0].qualified_non_qualified_sales_list[0].non_qualified[0].no_sales_have_avg_count
          var AvgNoSale = response.data[0].qualified_non_qualified_sales_list[0].non_qualified[0].no_sales_no_avg_count
          var Qualified = response.data[0].qualified_non_qualified_sales_list[0].non_qualified[0].current_qualified_count
          this.nonQualifiedCustomer(NonQSaleStarted, NonQNoSaleStarted, AvgNoSale, Qualified)
          // receivables
          var OverdueInactive = response.data[0].receivables_list[0].overdue_inactive_receivables_total
          var OverdueActive = response.data[0].receivables_list[0].overdue_active_receivables_total
          var DueInactive = response.data[0].receivables_list[0].due_inactive_receivables_total
          var DueActive = response.data[0].receivables_list[0].due_active_receivables_total
          var DoubtfulDebt = response.data[0].receivables_list[0].doubtful_debt_receivables_total
          this.receivablesChart(OverdueInactive, OverdueActive, DueInactive, DueActive, DoubtfulDebt)

        }

      },
      error: (err) => {
        this.FilterLoader = false
        alert('Server error')
      }
    })
  }




  // inditual chart fn 

  salesCustomerValue(NonQualifiedActivevalue: any, NonQualifiedInactivevalue: any, Qualifiedactivevalue: any, QualifiedInactivevalue: any) {
    var CustomercountPercent = this.percentCalculate([NonQualifiedActivevalue, NonQualifiedInactivevalue, Qualifiedactivevalue, QualifiedInactivevalue]);
    this.EmployeeCustomerpieChartLabels = [['Non Qualified Active ' + CustomercountPercent[0] + '%'], ['Non Qualified Inactive ' + CustomercountPercent[1] + '%'], 'Qualified Active ' + CustomercountPercent[2] + '%', 'Qualified Inactive ' + CustomercountPercent[3] + '%'];
    this.EmployeeCustomerpieChartDatasets = [{
      data: [NonQualifiedActivevalue, NonQualifiedInactivevalue, Qualifiedactivevalue, QualifiedInactivevalue],
      backgroundColor: [this.SaleStarted, this.QnotStarted, this.Active, this.NotStarted], // Add custom colors here
      borderColor: [this.SaleStarted, this.QnotStarted, this.Active, this.NotStarted], // Optional: border colors
      borderWidth: 1
    }];
  }

  salesCustomercount(NonQualifiedActive: any, NonQualifiedInactive: any, Qualifiedactive: any, QualifiedInactive: any) {
    var CustomercountPercent = this.percentCalculate([NonQualifiedActive, NonQualifiedInactive, Qualifiedactive, QualifiedInactive]);
    this.EmployeeCustomercountpieChartLabels = [['Non Qualified Active ' + CustomercountPercent[0] + '%'], ['Non Qualified Inactive ' + CustomercountPercent[1] + '%'], 'Qualified Active ' + CustomercountPercent[2] + '%', 'Qualified Inactive ' + CustomercountPercent[3] + '%'];
    this.EmployeeCustomercountpieChartDatasets = [{
      data: [NonQualifiedActive, NonQualifiedInactive, Qualifiedactive, QualifiedInactive],
      backgroundColor: [this.SaleStarted, this.QnotStarted, this.Active, this.NotStarted], // Add custom colors here
      borderColor: [this.SaleStarted, this.QnotStarted, this.Active, this.NotStarted], // Optional: border colors
      borderWidth: 1
    }];

  }


  // AdminView
  getPiechart() {
    this.FilterLoader = true
    this.adminService.dashboardPiechart(this.EmployeeId, this.Department, this.SearchString).subscribe(
      {
        next: (response) => {
          console.log(response);
          // qualified
          if (response.success) {
            this.FilterLoader = false
            var SaleStarted = response.data[0].qualified_non_qualified_sales_list[0].qualified[0].sales_started_count
            var NoSaleStarted = response.data[0].qualified_non_qualified_sales_list[0].qualified[0].no_sales_count
            var ActiveCustomer = response.data[0].qualified_non_qualified_sales_list[0].qualified[0].qualified_count
            var ActiveQualifiedSales = response.data[0].qualified_non_qualified_sales_list[0].qualified[0].active_qualified_sales_count
            this.qualifiedCustomer(SaleStarted, NoSaleStarted, ActiveCustomer, ActiveQualifiedSales)
            //non qualified
            var NonQSaleStarted = response.data[0].qualified_non_qualified_sales_list[0].non_qualified[0].sales_started_count
            var NonQNoSaleStarted = response.data[0].qualified_non_qualified_sales_list[0].non_qualified[0].no_sales_have_avg_count
            var AvgNoSale = response.data[0].qualified_non_qualified_sales_list[0].non_qualified[0].no_sales_no_avg_count
            var Qualified = response.data[0].qualified_non_qualified_sales_list[0].non_qualified[0].current_qualified_count
            this.nonQualifiedCustomer(NonQSaleStarted, NonQNoSaleStarted, AvgNoSale, Qualified)
            // receivables
            var OverdueInactive = response.data[0].receivables_list[0].overdue_inactive_receivables_total
            var OverdueActive = response.data[0].receivables_list[0].overdue_active_receivables_total
            var DueInactive = response.data[0].receivables_list[0].due_inactive_receivables_total
            var DueActive = response.data[0].receivables_list[0].due_active_receivables_total
            var DoubtfulDebt = response.data[0].receivables_list[0].doubtful_debt_receivables_total
            this.receivablesChart(OverdueInactive, OverdueActive, DueInactive, DueActive, DoubtfulDebt)
          } else {
            this.FilterLoader = false
            this.adminService.showToast('error', 'Something went wrong ! try again')
          }
        },
        error: (err) => {
          alert('Server error')
          this.FilterLoader = false
        },
      }
    )
  }



  //percentage calc

  percentCalculate(dataValues: number[]): number[] {
    const total = dataValues.reduce((sum, value) => sum + value, 0);
    return dataValues.map(value => {
      const percentage = (total === 0 ? 0 : (value / total) * 100);
      return parseFloat(percentage.toFixed(2));
    });
  }


  // Chart rendering Functionalities

  qualifiedCustomer(SaleStarted: any, NoSaleStarted: any, ActiveCustomer: any, ActiveQualifiedSales: any) {
    this.QualifiedPercentage = this.percentCalculate([SaleStarted, NoSaleStarted, ActiveCustomer, ActiveQualifiedSales]);
    this.pieChartLabels = [['Sales Started ' + this.QualifiedPercentage[0] + '%'], ['Sales not Started ' + this.QualifiedPercentage[1] + '%'], 'Active customer ' + this.QualifiedPercentage[2] + '%', 'Qualified sales ' + this.QualifiedPercentage[3] + '%'];
    this.pieChartDatasets = [{
      data: [SaleStarted, NoSaleStarted, ActiveCustomer, ActiveQualifiedSales],
      backgroundColor: [this.SaleStarted, this.NotStarted, this.Active, this.Doubtful], // Add custom colors here
      borderColor: [this.SaleStarted, this.NotStarted, this.Active, this.Doubtful], // Optional: border colors
      borderWidth: 1,
    }]
  }

  nonQualifiedCustomer(NonQSaleStarted: any, NonQNoSaleStarted: any, AvgNoSale: any, Qualified: any) {
    this.NonQualifiedPercentage = this.percentCalculate([NonQSaleStarted, NonQNoSaleStarted, AvgNoSale, Qualified]);
    this.nonpieChartLabels = [['Sales Started ' + this.NonQualifiedPercentage[0] + "%"], ['Sales not Started ' + this.NonQualifiedPercentage[1] + "%"], 'Avg no sales ' + this.NonQualifiedPercentage[2] + '%', 'Qualified ' + this.NonQualifiedPercentage[3] + '%'];

    this.nonpieChartDatasets = [{
      data: [NonQSaleStarted, NonQNoSaleStarted, AvgNoSale, Qualified],
      backgroundColor: [this.SaleStarted, this.QnotStarted, this.Doubtful, this.Active], // Add custom colors here
      borderColor: [this.SaleStarted, this.QnotStarted, this.Doubtful, this.Active], // Optional: border colors
      borderWidth: 1,

    }];
  }

  receivablesChart(OverdueInactive: any, OverdueActive: any, DueInactive: any, DueActive: any, DoubtfulDebt: any) {
    this.RecivablePercentage = this.percentCalculate([OverdueInactive, OverdueActive, DueInactive, DueActive, DoubtfulDebt]);
    this.ReceivablespieChartLabels = [['Overdue Inactive ' + this.RecivablePercentage[0] + '%'], ['Overdue Active ' + this.RecivablePercentage[1] + '%'], 'Due Inactive ' + this.RecivablePercentage[2] + '%', 'Due Active ' + this.RecivablePercentage[3] + '%', 'Doubtful Debt ' + this.RecivablePercentage[4] + '%'];


    this.ReceivablespieChartDatasets = [{
      data: [OverdueInactive, OverdueActive, DueInactive, DueActive, DoubtfulDebt],
      backgroundColor: [this.NotStarted, this.SaleStarted, this.QnotStarted, this.Active, this.Doubtful], // Add custom colors here
      borderColor: [this.NotStarted, this.SaleStarted, this.QnotStarted, this.Active, this.Doubtful], // Optional: border colors
      borderWidth: 1
    }];
  }



  // Pie chart varibles////////////////////////////////////////////////////////////////
  // new
  public pieChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    aspectRatio: 2,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          boxWidth: 10,
          padding: 6,
          font: {
            size: 11
          }
        }
      },
      tooltip: {
        position: 'nearest'
      }
    }
  };
  public pieChartLabels = [['Sales Started'], ['Sales not Started'], 'Active customer', 'Qualified sales'];
  public pieChartDatasets = [{
    data: [0, 0, 0, 0],
    backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#0A0A0A'], // Add custom colors here
    borderColor: ['#FF6384', '#36A2EB', '#FFCE56', '#0A0A0A'], // Optional: border colors
    borderWidth: 1,
  }];
  public nonpieChartLabels = [['Sales Started'], ['Sales not Started'], 'Avg no sales', 'Qualified'];
  public nonpieChartDatasets = [{
    data: [0, 0, 0, 0],
    backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Add custom colors here
    borderColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Optional: border colors
    borderWidth: 1,
  }];
  public ReceivablespieChartLabels = [['Overdue Inactive'], ['Overdue Active'], 'Due Inactive', 'Due Active', 'Doubtful Debt'];
  public ReceivablespieChartDatasets = [{
    data: [0, 0, 0, 0, 0],
    backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Add custom colors here
    borderColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Optional: border colors
    borderWidth: 1
  }];
  // indivitual chart
  public EmployeeCustomercountpieChartLabels = [['Non Qualified Active'], ['Non Qualified Inactive'], 'Qualified Active', 'Qualified Inactive'];
  public EmployeeCustomercountpieChartDatasets = [{
    data: [0, 0, 0, 0],
    backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Add custom colors here
    borderColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Optional: border colors
    borderWidth: 1
  }];
  public EmployeeCustomerpieChartLabels = [['Non Qualified Active'], ['Non Qualified Inactive'], 'Qualified Active', 'Qualified Inactive'];
  public EmployeeCustomerpieChartDatasets = [{
    data: [0, 0, 0, 0],
    backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Add custom colors here
    borderColor: ['#FF6384', '#36A2EB', '#FFCE56'], // Optional: border colors
    borderWidth: 1
  }];
  public pieChartLegend = true;
  public pieChartPlugins = [];






}
